import api from './api';

export async function consultarHangfireStatus(recentLimit = 50) {
  return api.get(`Monitor/HangfireStatus?recentLimit=${recentLimit}`);
}

export async function triggerRecurringJob(jobId) {
  return api.post(`Monitor/RecurringJobs/${encodeURIComponent(jobId)}/Trigger`);
}

export async function reprogramarRecurringJob(jobId, horario) {
  return api.put(`Monitor/RecurringJobs/${encodeURIComponent(jobId)}/Horario`, {
    horario,
  });
}
